// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-step-progress {
    display: flex;
}

.progress-fill {
    background-color: #007bff;
    width: 100%;
    position: absolute;
    bottom: 0;
    transition: height 0.3s ease-in-out;
}

.progress-steps {
    display: flex;
    flex-direction: column;
}

.progress-step {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    position: relative;
}

.step-number {
    color: #007bff;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border: 2px solid #007bff;
    position: relative;
}

.done .step-number {
    background-color: #007bff;
    color: #fff;
}

.in-progress .step-number {
    background-color: #fff;
}

.milestone-line1 {
    display: block;
    margin-right: 10px;
}

#milestone-description {
    font-weight: 500;
    margin-left: 10px;
    font-size: 10pt;
}

#milestone-location {
    margin-left: 0px;
    font-weight: 300;
    margin-left: 10px;
    font-size: 10pt;
}

.milestone-line2 {
    display: inline-block;
    margin-right: 10px;
}

#milestone-timestamp {
    margin-left: 10px;
    font-weight: 200;
    font-size: 10pt;
}

#milestone-source {
    font-weight: lighter;
    font-size: 10pt;
    font-style: oblique;
}

/* New styles for the vertical line */
.progress-step:not(:last-child) .step-number::after {
    content: '';
    position: absolute;
    width: 2px;
    background-color: #007bff;
    top: calc(100%);
    /*Adjust as needed*/
    left: 50%;
    transform: translateX(-50%);
    height: calc(275%);
    /* Adjust as needed */
}`, "",{"version":3,"sources":["webpack://./src/components/VerticalStepProgress.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":[".vertical-step-progress {\n    display: flex;\n}\n\n.progress-fill {\n    background-color: #007bff;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    transition: height 0.3s ease-in-out;\n}\n\n.progress-steps {\n    display: flex;\n    flex-direction: column;\n}\n\n.progress-step {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n    position: relative;\n}\n\n.step-number {\n    color: #007bff;\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    border: 2px solid #007bff;\n    position: relative;\n}\n\n.done .step-number {\n    background-color: #007bff;\n    color: #fff;\n}\n\n.in-progress .step-number {\n    background-color: #fff;\n}\n\n.milestone-line1 {\n    display: block;\n    margin-right: 10px;\n}\n\n#milestone-description {\n    font-weight: 500;\n    margin-left: 10px;\n    font-size: 10pt;\n}\n\n#milestone-location {\n    margin-left: 0px;\n    font-weight: 300;\n    margin-left: 10px;\n    font-size: 10pt;\n}\n\n.milestone-line2 {\n    display: inline-block;\n    margin-right: 10px;\n}\n\n#milestone-timestamp {\n    margin-left: 10px;\n    font-weight: 200;\n    font-size: 10pt;\n}\n\n#milestone-source {\n    font-weight: lighter;\n    font-size: 10pt;\n    font-style: oblique;\n}\n\n/* New styles for the vertical line */\n.progress-step:not(:last-child) .step-number::after {\n    content: '';\n    position: absolute;\n    width: 2px;\n    background-color: #007bff;\n    top: calc(100%);\n    /*Adjust as needed*/\n    left: 50%;\n    transform: translateX(-50%);\n    height: calc(275%);\n    /* Adjust as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
